import { useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../../features/userSlice";

const AuthRedirect = ({ children }) => {
  const { isAuthenticated, loading } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else if (token && !isAuthenticated) {
      dispatch(getLoggedInUser("logged-in-user")).unwrap();
      navigate("/dashboard");
    }
    // }, []);
  }, [dispatch, navigate, isAuthenticated, token, loading]);
  if (!isAuthenticated && !token) return <>{children}</>;
};

export default AuthRedirect;
